var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animations"},[_c('h1',{staticClass:"h1 animate__animated animate__jackInTheBox"},[_vm._v(" "+_vm._s(_vm.animations.text ? _vm.animations.text : "")+" ")]),(_vm.animations.gif)?_c('img',{class:{
      'animate__animated animate__delay-1s':
        _vm.animations.gif != 'fireworks' && _vm.animations.gif != 'star'
    },attrs:{"src":'/images/application/animations/' + _vm.animations.gif + '.gif',"alt":"Animations"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }